export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12786.86d94ba5.jpg";